<template>
  <div class="data-management-add">
    <div v-loading="videoLoding" class="tuolele-main-box">
      <div class="data-form">
        <div class="form-row">
          <div class="form-input important">
            <span>资料标题</span>
            <el-input
              v-model="articleObj.title"
              size="large"
              placeholder="请输入标题"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-input important fn-clear">
            <span class="fn-left">封面图片</span>
            <div class="upload-cover fn-left">
              <el-upload
                class="avatar-uploader"
                accept=".jpg, .png"
                :action="qiniuUrl"
                :data="imageToken"
                :show-file-list="false"
                :on-success="handleCoverSuccess"
                :before-upload="beforeCoverUpload"
              >
                <img
                  v-if="articleObj.cover"
                  :src="articleObj.cover"
                  class="avatar"
                >
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
              <div class="upload-notice">
                <span>除操作指南外，其他资料封面图片必传</span>建议封面上传图片尺寸比例为：4:3（例：400px:300px）
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-input important">
            <span>所属分类</span>
            <el-cascader
              v-model="directory_ids"
              :options="optionsCascader"
              :props="{
                value: 'id',
                label: 'directory_name',
                children: '_child',
                expandTrigger: 'hover',
                emitPath: false,
                checkStrictly: false,
                multiple: true
              }"
              :show-all-levels="false"
              @change="changeDataType"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-input fn-clear important">
            <span class="fn-left">适用时段</span>
            <div class="fn-left">
              <Checkbox
                :list.sync="times"
                :select-list="time_frame"
                @updateCheck="updateCheck"
              />
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-input">
            <span>是否推荐</span>
            <el-radio-group v-model="articleObj.is_recommend">
              <el-radio :label="'0'">非推荐</el-radio>
              <el-radio :label="'1'">推荐</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row">
          <div class="form-input important">
            <span>资料类型</span>
            <el-radio-group v-model="articleObj.type">
              <el-radio :label="'1'">图文</el-radio>
              <el-radio :label="'2'">视频</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-show="articleObj.type == 1" class="form-row">
          <div class="form-input fn-clear important editor">
            <span class="fn-left">图文详情</span>
            <div class="fn-left">
              <div class="upload-notice">
                <span>上传图片最大宽度为900px，超出此宽度后将影响显示效果</span>
              </div>
              <quill-editor
                ref="myQuillEditor"
                v-model="articleObj.content"
                :options="editorOption"
              />
              <el-upload
                ref="upload"
                accept=".jpg, .png"
                :action="qiniuUrl"
                :data="imageToken"
                :show-file-list="false"
                :on-success="handleImgSuccess"
                :before-upload="beforeCoverUpload"
                style="display:none"
              >
                <el-button
                  id="imgInput"
                  size="small"
                  type="primary"
                >点击上传</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div v-show="articleObj.type == 2" class="form-row">
          <div class="form-input important fn-clear">
            <span class="fn-left">视频上传</span>
            <span v-show="videoObj.name" class="fn-left main-font-color">{{
              videoObj.name
            }}</span>
            <div class="upload-video fn-left">
              <el-upload
                accept=".mp4"
                :action="qiniuUrl"
                :data="fileToken"
                :show-file-list="false"
                :on-success="handleVideoSuccess"
                :before-upload="beforeVideoUpload"
              >
                <el-button slot="trigger" size="small" type="primary">{{
                  videoObj.name == "" ? "选择视频" : "重新上传"
                }}</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-input fn-clear">
            <span class="fn-left">添加附件</span>
            <div class="upload-video fn-left">
              <el-upload
                :action="qiniuUrl"
                :data="fileToken"
                :on-success="handleFileSuccess"
                :before-upload="beforeFileUpload"
                :on-remove="handleFileRemove"
                :file-list="fileList"
              >
                <el-button
                  slot="trigger"
                  size="small"
                  type="primary"
                >添加附件</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-input">
            <span>发布时间</span>
            <el-radio-group v-model="articleObj.is_show">
              <el-radio :label="'1'">立即发布</el-radio>
              <el-radio :label="'0'">暂不发布</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row">
          <div class="form-input">
            <el-button type="primary" @click="confirmAdd">确认</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/toolbar/Checkbox.vue'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import qiniuUpload from '@/assets/js/upload.js'
export default {
  name: 'DataManagementAdd',
  components: {
    Checkbox,
    quillEditor
  },
  data() {
    return {
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          // 配置富文本
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote'],
              [{ header: 1 }, { header: 2 }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['image']
            ],
            handlers: {
              image: function(val) {
                if (val) {
                  document.querySelector('#imgInput').click()
                }
              }
            }
          }
        }
      },
      optionsCascader: [],
      times: [
        {
          text: '通用',
          value: '1'
        },
        {
          text: '春季',
          value: '2'
        },
        {
          text: '暑假',
          value: '3'
        },
        {
          text: '秋季',
          value: '4'
        },
        {
          text: '寒假',
          value: '5'
        }
      ],
      time_frame: [],
      articleObj: {
        id: '',
        title: '',
        cover: '',
        directory_ids: '',
        time_frame: '',
        is_recommend: '',
        type: '',
        is_show: '1',
        content: '',
        file_ids: '',
        attachment_ids: ''
      },
      qiniuUrl: qiniuUpload.qiniuUrl,
      imageToken: {
        token: '',
        key: ''
      },
      fileToken: {
        token: '',
        key: ''
      },
      videoObj: {
        name: '',
        url: ''
      },
      videoLoding: false,
      fileList: [],
      directory_ids: []
    }
  },
  created() {
    this.imgToken()
    this.fToken()
  },
  mounted() {
    this.getDirectoryListTree()
    const id = this.$route.query.id
    if (id) {
      this.getArticleInfo(id)
    }
  },
  methods: {
    async getArticleInfo(id) {
      const ret = await this.$http.getArticleInfo({ id })
      if (ret.code == 200) {
        this.articleObj.id = ret.data.id
        this.articleObj.title = ret.data.title
        this.articleObj.cover = ret.data.cover
        this.articleObj.directory_ids = ret.data.directory_ids
        this.directory_ids = ret.data.directory_ids.split(',')
        this.time_frame = ret.data.time_frame.split(',')
        this.articleObj.time_frame = ret.data.time_frame
        this.articleObj.is_recommend = ret.data.is_recommend
        this.articleObj.type = ret.data.type
        this.articleObj.content = ret.data.content
        this.articleObj.file_ids = ret.data.file_ids
        this.articleObj.attachment_ids = ret.data.attachment_ids
        this.articleObj.is_show = ret.data.is_show
        if (ret.data.attachments && ret.data.attachments.length > 0) {
          ret.data.attachments.forEach(e => {
            this.fileList.push({
              id: e.id,
              name: e.name,
              url: e.file_url
            })
          })
        }
        if (ret.data.files && ret.data.files.length > 0) {
          this.videoObj = ret.data.files[0]
        }
      }
    },
    async imgToken() {
      const ret = await this.$http.imgToken()
      this.imageToken.token = ret.token
    },
    async fToken() {
      const ret = await this.$http.fToken()
      this.fileToken.token = ret.token
    },
    async getDirectoryListTree() {
      const ret = await this.$http.getDirectoryListTree()
      if (ret.code == 200) {
        this.optionsCascader = ret.data
      }
    },
    async filesImprove(params) {
      const ret = await this.$http.filesImprove(params)
      return ret
    },
    changeDataType(val) {
      this.articleObj.directory_ids = val.join(',')
    },
    updateCheck(val) {
      this.time_frame = val
      this.articleObj.time_frame = val.join(',')
    },
    beforeCoverUpload(file) {
      const type = file.name.split('.')[1]
      if (type != 'jpg' && type != 'jpeg' && type != 'png') {
        this.$message({
          type: 'warning',
          message: '文件格式不正确'
        })
        return false
      }
      this.imageToken.key =
        new Date().getTime() + '' + Math.ceil(Math.random() * 10000) + '.jpg'
    },
    handleCoverSuccess(ret) {
      this.articleObj.cover = qiniuUpload.imgSpace + ret.key
    },
    handleImgSuccess(ret) {
      const quill = this.$refs.myQuillEditor.quill
      const length = quill.getSelection().index
      quill.insertEmbed(length, 'image', qiniuUpload.imgSpace + ret.key)
      quill.setSelection(length + 1)
    },
    beforeVideoUpload(file) {
      const type = file.name.split('.').pop()
      if (type != 'mp4') {
        this.$message({
          type: 'warning',
          message: '文件格式不正确'
        })
        return false
      }
      this.videoLoding = true
      this.fileToken.key =
        new Date().getTime() +
        '' +
        Math.ceil(Math.random() * 10000) +
        '.' +
        type
    },
    handleVideoSuccess(ret, file) {
      const me = this
      const url = qiniuUpload.fileSpace + ret.key
      me.videoObj.url = url
      me.videoObj.name = file.name
      const names = file.name.split('.')
      const mimeType = names.pop()
      const params = {
        name: names.join('.'),
        file_name: ret.key.split('.')[0],
        file_suffix: mimeType,
        file_url: url,
        file_size: file.size
      }
      this.videoLoding = false
      me.filesImprove(params).then(res => {
        me.articleObj.file_ids = res.data.file_id
      })
    },
    beforeFileUpload(file) {
      const type = file.name.split('.').pop()
      this.fileToken.key =
        new Date().getTime() +
        '' +
        Math.ceil(Math.random() * 10000) +
        '.' +
        type
    },
    handleFileSuccess(ret, file) {
      const me = this
      const url = qiniuUpload.fileSpace + ret.key
      const names = file.name.split('.')
      const mimeType = names.pop()
      const params = {
        name: names.join('.'),
        file_name: ret.key.split('.')[0],
        file_suffix: mimeType,
        file_url: url,
        file_size: file.size
      }
      me.filesImprove(params).then(res => {
        me.fileList.push({
          id: res.data.file_id,
          name: file.name,
          url: url
        })
      })
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList
    },
    async confirmAdd() {
      const ids = []
      this.fileList.forEach(e => {
        ids.push(e.id)
      })
      this.articleObj.attachment_ids = ids.join(',')
      if (!this.articleObj.title) {
        this.$message({
          type: 'warning',
          message: '请输入资料标题!'
        })
        return false
      }
      if (!this.articleObj.cover) {
        this.$message({
          type: 'warning',
          message: '请上传封面图片!'
        })
        return false
      }
      if (!this.articleObj.directory_ids) {
        this.$message({
          type: 'warning',
          message: '请选择资料分类!'
        })
        return false
      }
      if (!this.articleObj.time_frame) {
        this.$message({
          type: 'warning',
          message: '请选择适用时段!'
        })
        return false
      }
      if (!this.articleObj.type) {
        this.$message({
          type: 'warning',
          message: '请选择资料类型!'
        })
        return false
      }
      if (this.articleObj.type == 1 && !this.articleObj.content) {
        this.$message({
          type: 'warning',
          message: '请输入图文详情!'
        })
        return false
      }
      if (this.articleObj.type == 2 && !this.articleObj.file_ids) {
        this.$message({
          type: 'warning',
          message: '请上传视频!'
        })
        return false
      }
      const ret = await this.$http.improveArticle(this.articleObj)
      if (ret.code == 200) {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tuolele-main-box {
  .data-form {
    .form-row {
      .form-input {
        &.editor {
          height: 530px;
        }
        .upload-notice {
          font-size: 14px;
          color: $color_normal;
          span {
            color: #ff6c4c;
            font-size: 14px;
          }
        }
      }
    }
  }
}

.el-cascader {
  width: 500px;
  .el-input {
    width: 100%;
    span {
      margin-right: 0 !important;
    }
  }
}

.el-input {
  width: 500px;
}

.avatar-uploader {
  .el-upload {
    cursor: pointer;
    position: relative;
    .avatar-uploader-icon {
      border: 1px solid $color_blue;
      border-radius: 4px;
      font-size: 28px;
      color: $color_blue;
      width: 120px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      overflow: hidden;
    }
    .avatar {
      border: 1px solid $color_blue;
      border-radius: 4px;
      width: 120px;
      height: 90px;
      display: block;
      overflow: hidden;
    }
  }
}

.el-radio-group {
  span {
    margin-right: 0 !important;
  }
}
.quill-editor {
  height: 400px;
}

.el-radio {
  height: 40px;
  margin-right: 30px;
  line-height: 37px;
}

.el-button.el-button--primary {
  width: 90px;
  height: 40px;
}
</style>
